import { render } from "./Login.vue?vue&type=template&id=d90871bc&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=d90871bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d90871bc"

export default script